module.exports = __webpack_public_path__ + "static/media/Cross.b1b96ebb.svg";